import React, { useEffect, useMemo, useState } from "react";

import { useFetch } from "../../../Utils/useFetch";

import { FETCH_ALL_SHIPPING_API } from "../../../Constants/Apis";
import { Button, Modal, Space, Table, Tag, Typography } from "antd";
import { WarningOutlined, CarOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { Text } = Typography;

const WelcomePage = ({ history, userData }) => {
  const isAdmin = userData?.roles?.includes("admin");
  const [overdueModalVisible, setOverdueModalVisible] = useState(false);
  const [lateShippings, setLateShippings] = useState([]);

  const shippingQueryParams = useMemo(
    () => ({
      current: 1,
      pageSize: 50000,
      searchKeyword: "",
      sorter: {},
      filteredInfo: {
        status: ["in delivery"],
      },
    }),
    []
  );

  const { fetchedData: shippingData, callReFetch: fetchShippingData } = useFetch(
    FETCH_ALL_SHIPPING_API,
    shippingQueryParams,
    history,
    { enabled: false }
  );

  useEffect(() => {
    if (isAdmin) {
      fetchShippingData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  useEffect(() => {
    if (!isAdmin) return;

    const data = shippingData?.data?.data || [];
    if (!Array.isArray(data) || data.length === 0) return;

    const todayStr = dayjs().format("YYYY-MM-DD");
    const lastShownInSession = sessionStorage.getItem(
      "overdue_alert_session_shown_date"
    );

    if (lastShownInSession === todayStr) return;

    const today = dayjs().startOf("day");
    const lateItems = data
      .filter((item) => {
        if (!item.tanggal_terima_eta) return false;
        const etaDate = dayjs(item.tanggal_terima_eta).startOf("day");
        const diff = today.diff(etaDate, "day");
        return diff > 0 && diff <= 30;
      })
      .map((item) => {
        const etaDate = dayjs(item.tanggal_terima_eta).startOf("day");
        return {
          ...item,
          daysLate: today.diff(etaDate, "day"),
        };
      });

    if (lateItems.length > 0) {
      setLateShippings(lateItems);
      setOverdueModalVisible(true);
      sessionStorage.setItem("overdue_alert_session_shown_date", todayStr);
    }
  }, [isAdmin, shippingData]);

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    padding: "16px",
    textAlign: "center",
    backgroundColor: "#f4f4f4",
  };

  const cardStyle = {
    backgroundColor: "white",
    padding: "24px",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    maxWidth: "400px",
    width: "100%",
    textAlign: "center",
  };

  const deptStyle = {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1a202c",
    marginBottom: "8px",
  };

  const welcomeStyle = {
    fontSize: "20px",
    color: "#2d3748",
    marginBottom: "16px",
  };

  return (
    <>
      <div style={containerStyle}>
        <div style={cardStyle}>
          <h1 style={deptStyle}>{userData.dept}</h1>
          <h3 style={welcomeStyle}>Welcome, {userData.name}</h3>
        </div>
      </div>

      <Modal
        title={
          <Space>
            <WarningOutlined style={{ color: "#ff4d4f" }} />
            <span style={{ color: "#cf1322" }}>Overdue Shipments Warning</span>
          </Space>
        }
        open={overdueModalVisible}
        onCancel={() => setOverdueModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setOverdueModalVisible(false)}>
            Close
          </Button>,
          <Button
            key="view"
            type="primary"
            danger
            icon={<CarOutlined />}
            onClick={() => {
              setOverdueModalVisible(false);
              history.push("/user/shipping");
            }}
          >
            Go to Shipping Management
          </Button>,
        ]}
        width={700}
      >
        <div style={{ marginBottom: 16 }}>
          <p style={{ color: "#4a5568" }}>
            System detected shipments that are past their Estimated Arrival Date
            and have not been received yet. Please check with the logistics team.
          </p>
        </div>
        <Table
          dataSource={lateShippings}
          pagination={{ pageSize: 5 }}
          size="small"
          rowKey={(record) => record._id || record.id || record.noSJ}
          columns={[
            {
              title: "No Surat Jalan",
              dataIndex: "noSJ",
              key: "noSJ",
              render: (text) => <Text strong>{text}</Text>,
            },
            {
              title: "ETA Date",
              dataIndex: "tanggal_terima_eta",
              key: "tanggal_terima_eta",
              render: (value) =>
                value ? dayjs(value).format("YYYY-MM-DD") : "-",
            },
            {
              title: "Delay",
              dataIndex: "daysLate",
              key: "daysLate",
              render: (days) => (
                <Tag color="red">
                  {days} day{days !== 1 ? "s" : ""} late
                </Tag>
              ),
            },
          ]}
        />
      </Modal>
    </>
  );
};

WelcomePage.propWelcomes = {};

export default WelcomePage;
